export default function websocketModifier(websocket) {
    const modifiedWebsocket = websocket;
    modifiedWebsocket.sessionId = null;
    return modifiedWebsocket;
}
//# sourceMappingURL=websocketModifier.util.js.map